import type {
  CheckPayload,
  ChecksCountPayload,
} from '@app/shared/types/sf-data'
import SFetch from '@app/utils/sfetch'
import { getAssistantChecksPath, getUnreadChecksPath } from '../utils'

type toggleCheckEndpointType =
  | 'unread_ledger_assistant_checks_v2_index_path'
  | 'read_ledger_assistant_checks_v2_index_path'

const getUrl = (type: 'read' | 'unread'): string => {
  const route =
    `${type}_ledger_assistant_checks_v2_index_path` as toggleCheckEndpointType

  return window.Silverfin.Routes[route](
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    window.Silverfin.currentLedgerId()
  )
}

const toggleChecks = ({
  type,
  checkIds,
}: {
  type: 'read' | 'unread'
  checkIds: string[]
}): Promise<void | null> => {
  const url = getUrl(type)

  return SFetch.json(`${url}`, {
    method: 'POST',
    body: { ids: checkIds },
  })
}

const getChecksByLedger = (
  options?: Record<string, unknown>
): Promise<CheckPayload | null> => {
  const url = getAssistantChecksPath(options)

  return SFetch.json<CheckPayload>(`${url}`)
}

const getUnreadChecksCount = (
  workflowId?: number | null
): Promise<ChecksCountPayload | null> => {
  const url = getUnreadChecksPath(workflowId)

  return SFetch.json<ChecksCountPayload>(`${url}`)
}

export { toggleChecks, getChecksByLedger, getUnreadChecksCount }
